import { render, staticRenderFns } from "./AmountStatistics.vue?vue&type=template&id=673dc558&scoped=true&"
import script from "./AmountStatistics.vue?vue&type=script&lang=js&"
export * from "./AmountStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AmountStatistics.vue?vue&type=style&index=0&id=673dc558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673dc558",
  null
  
)

export default component.exports